import { Box } from '@mui/material'
import { FC, ReactNode, useState } from 'react'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { AppFooter } from './AppFooter'
import { ConsentimentoGate } from '@/components/common/ConsentimentoGate'

interface MainLayoutProps {
  children: ReactNode
}

export const MainLayout: FC<MainLayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  return (
    <ConsentimentoGate>
    <Box sx={{ display: 'flex', backgroundColor: '#F0F0F2', minHeight: '100vh' }}>
      <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
        }}
      >
        <TopBar sidebarCollapsed={sidebarCollapsed} />

        <Box
          component="main"
          sx={{
            flex: 1,
            marginTop: '64px',
            padding: '24px 28px',
            overflow: 'auto',
            maxWidth: '100%',
          }}
        >
          {children}
        </Box>
        <AppFooter />
      </Box>
    </Box>
    </ConsentimentoGate>
  )
}
